import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { OAuthCallbackRequest } from "../McpServerRecord";

import { mcpTokenStatusesQueryKey } from "./useMcpTokenStatuses";

interface CallbackParams {
  request: OAuthCallbackRequest;
}

export function useOAuthCallback(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ request }: CallbackParams) =>
      mcpRegistryService.oauthCallback(request, orgId!),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: mcpTokenStatusesQueryKey(orgId),
      });
    },
  });
}
